import {validateRequired} from "./ValidationFunctions";

const dailyPatrolLogFieldConfig = {
  fields: {
    title_label: {
      type: 'text',
      label: 'Title label',
      rules: [validateRequired('Title label')]
    },
    type_label: {
      type: 'text',
      label: 'Type label',
      rules: [validateRequired('Type label')]
    },
    location_label: {
      type: 'text',
      label: 'Location label',
      rules: [validateRequired('Location label')]
    },
    activity_label: {
      type: 'text',
      label: 'Activity label',
      rules: [validateRequired('Activity label')]
    },
    action_label: {
      type: 'text',
      label: 'Action label',
      rules: [validateRequired('Action label')]
    },
  }
}


export {
  dailyPatrolLogFieldConfig
}
